import { render, staticRenderFns } from "./monthly-expense-item.vue?vue&type=template&id=6f9112af"
import script from "./monthly-expense-item.vue?vue&type=script&lang=js"
export * from "./monthly-expense-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports